import { Injectable } from "@angular/core";

import { EventSourcePolyfill } from "event-source-polyfill";
import { env } from "@env/environment";
import { Observable } from "rxjs";
import { EventoDTO } from "../dto/eventoDTO";
import { EventiStore } from "../store/eventi.store";
import { ISubscription } from "rxjs/Subscription";
import { AutenticazioneService } from "./autenticazione.service";

@Injectable({
  providedIn: "root",
})
export class EventiService {
  private eventiUrl: string = env.API_URL_BASE + env.URL_EVENTI;

  private retry: number = 0;

  private subscription: ISubscription;
  constructor(private eventiStore: EventiStore, private autenticazioneService: AutenticazioneService) {}

  public getEvents() {

    const eventSource: EventSourcePolyfill = new EventSourcePolyfill(
      this.eventiUrl,
      {
        headers: {
          Authorization: "Bearer " + this.autenticazioneService.getUtente().token,
        },
      }
    );

    this.subscription = new Observable((observer) => {
      eventSource.onopen = (open) => {
        console.log("[getEvents] connesso: ", open);
        this.retry = -1;
      };

      eventSource.onmessage = (payload) => {
        console.log("[getEvents] payload: ", payload.data);
        if (payload.data) {
          const evento: EventoDTO = JSON.parse(payload.data);
          console.log("[getEvents] nuovo eventoDTO: ", evento);
          this.eventiStore.pushEvento(evento);
        }
      };

      eventSource.onerror = (error) => {
        console.log("[getEvents] errore: ", error);
        this.restartEvents(observer, eventSource);
      };
    }).subscribe();
  }

  private restartEvents(observer, eventSource) {
    observer.complete();
    eventSource.close();
    this.retry++;
    new Promise((resolve) =>
      setTimeout(resolve, 5000 * Math.min(this.retry, 10))
    ).then((_) => {
      console.log("[restartEvents] ");
      this.subscription.unsubscribe();
      this.getEvents();
    });
  }
}
